import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import messages from '../messages';
import style from '../style.module.less';
import { ConnectShipperHQButton } from './connect-shipperhq-button';
import ConnectionsGrid from './connections-grid';
import ShipperHQContextProvider, { ShipperHQContext } from './context';
import HelpArticleLink from '../../../../components/help-article-link';
import { linkIDs } from '../../../../services/link-service/links';
import { SettingsPageTitle } from '../../components/settings-page-title/settings-page-title';

const ShipperHQ = () => {
  const { storeConnectionGuids } = useContext(ShipperHQContext);
  const connectionsPresent = !!storeConnectionGuids.length;
  return (
    <div className={style['settings-section']}>
      <SettingsPageTitle value={messages.shipperHQName} />
      <div className={style['shipperHQ-subtext']}>
        <FormattedMessage
          {...messages.shipperHQ}
          values={{
            a: (chunks) => <HelpArticleLink articleId={linkIDs.ShipperHq}>{chunks}</HelpArticleLink>,
          }}
        />
      </div>
      {connectionsPresent ? <ConnectionsGrid /> : null}
      <ConnectShipperHQButton />
    </div>
  );
};

export const ShipperHQPage = () => {
  return (
    <ShipperHQContextProvider>
      <ShipperHQ />
    </ShipperHQContextProvider>
  );
};
